import React, { useState, useEffect } from 'react';
import SelectDropdown from '../../../system/fields/SelectDropdown';
import { Field } from 'redux-form';

const DealSubcatagoryDropdown = ({
  formValues,
  validate,
  SubCatagories,
  DealCatagory,
}) => {
  const [dealCategoryIds, setDealCategoryIds] = useState([]);
  const [deafaultSelected, setDefaultSelected] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  useEffect(() => {
    if (DealCatagory && DealCatagory.length > 0) {
      setDealCategoryIds(
        DealCatagory.map((category) => {
          return category.id;
        })
      );
    } else {
      setDealCategoryIds([]);
    }
  }, [DealCatagory]);

  useEffect(() => {
    if (isFirstLoad && formValues && formValues.sub_categories) {
      setIsFirstLoad(false);
      setDefaultSelected(
        formValues.sub_categories.map((el) => {
          const parent = DealCatagory.find((deal) => deal.id === el.parent_id);
          if (parent) {
            return (el.label = el.name + ' (' + parent.name + ')');
          }
        })
      );
    }
  }, [formValues, isFirstLoad]);

  return (
    <Field
      name='sub_categories'
      component={SelectDropdown}
      defaultValue={deafaultSelected}
      labelKey='label'
      valueKey='id'
      options={SubCatagories.filter((subcatagory) => {
        if (dealCategoryIds.includes(subcatagory.parent.id)) {
          subcatagory.label =
            subcatagory.name + ' ' + `(${subcatagory.parent.name})`;
        }
        return dealCategoryIds.includes(subcatagory.parent.id);
      })}
      validate={validate}
      autoFocus={true}
      multi
      placeholder={
        dealCategoryIds &&
        dealCategoryIds.length === 0 &&
        'Please select a deal category...'
      }
      disabled={dealCategoryIds && dealCategoryIds.length === 0}
    />
  );
};

export default DealSubcatagoryDropdown;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/DealSubcatagoryDropdown.jsx